// Paths that open in the left "current post" pane instead of replacing the feed.

const STATUS_PATH = /^\/(?:@([^/]+)\/(\d+)|statuses\/(\d+))\/?$/;
const PUBLISH_PATH = /^\/(?:publish|statuses\/new)\/?$/;

export interface StatusRoute {
  id: string;
  acct?: string;
}

export const parseStatusPath = (pathname: string): StatusRoute | null => {
  const match = STATUS_PATH.exec(pathname);

  if (!match) {
    return null;
  }

  return { id: match[2] ?? match[3] ?? '', acct: match[1] };
};

export const isPublishPath = (pathname: string) => PUBLISH_PATH.test(pathname);

/** Locations that never take over the middle (feed) column. */
export const isOverlayPath = (pathname: string) =>
  parseStatusPath(pathname) !== null || isPublishPath(pathname);
